import React from 'react';
import { Breadcrumb as BootstrapBreadcrumb } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';

// SVG 分隔箭頭不需額外載入 FontAwesome 字型。
const Breadcrumb = React.forwardRef(({ children, label = '現在位置', ...props }, ref) => (
    <BootstrapBreadcrumb {...props} label={label} ref={ref}>
        {React.Children.toArray(children).map((child, index) =>
            React.isValidElement(child) ? React.cloneElement(child, {}, <>
                {index > 0 && <FontAwesomeIcon icon={faAngleDoubleRight} className="breadcrumb-divider" aria-hidden="true" />}
                {child.props.children}
            </>) : child
        )}
    </BootstrapBreadcrumb>
));

Breadcrumb.displayName = 'Breadcrumb';
Breadcrumb.Item = BootstrapBreadcrumb.Item;
export default Breadcrumb;
